
import { pipe } from 'overmind'
import { AsyncAction, Context } from "src/state/_types"
import logger from 'src/utils/logger'; 
import { getDefaultUIView } from 'src/utils/state';

export const onInitializeOvermind: AsyncAction = pipe(
    async ({state,actions}: Context) => {
        state.loading = true;
        logger(`Initializing App`)
        state.ui.view = getDefaultUIView()
        actions.loadSettings()
    },
    async ({actions}: Context) => {
        actions.initializeAuth()
    },
    async ({actions}: Context) => {
        logger(`Application Initialized`)
        await actions.refreshSession();
        actions.initializeApi();
    },
    async ({state,actions}: Context) => {
        if(state.auth.session_id) {
            await actions.getProfile()
        }
    },
    async ({state,actions}: Context) => {
        state.loading = false;
        if (state.profile) {
            await actions.initializeSubscriptions()
            await actions.initializeNotifications()
            // LogRocket.identify(state.profile.id, {
            //     name: `${state.profile.first_name} ${state.profile.last_name}`,
            //     email: state.profile.email,
            //     tenant_id: state.profile.tenant_id,
            //     tenant: state.tenant.name || 'Unknown'
            // });
        }
    }
) 